/**
 *
 * @param path 路径
 * @returns
 */

export const isExternal = (path: string): boolean => {
  return /^(https?:|mailto:|tel:)/.test(path)
}
//判断是否为null、undefined、空字符串
export const judgeNullUndefinedEmptyString = (
  params: any,
  value: any,
  key: any
) => {
  if (params.nationality && params.nationality != '') {
    if (['name', 'sex', 'xm', 'csnf', 'zjdw', 'zjqsnf'].includes(key)) {
      if (!value || value == null || value == undefined || value == '') {
        return false
      }
      return true
    } else {
      return true
    }
  } else {
    if (!value || value == null || value == undefined || value == '') {
      if (key == 'xzcpjnf') {
        if (params.jszc == '5') {
          return true
        } else {
          return false
        }
      } else {
        return false
      }
    } else {
      return true
    }
  }
}
export const judgeNullUndefinedEmptyStringYdy = (
  params: any,
  value: any,
  key: any
) => {
  if (!value || value == null || value == undefined || value == '') {
    if (key == 'pjnf') {
      if (params.jsdj == '6') {
        return true
      } else {
        return false
      }
    } else {
      return false
    }
  } else {
    return true
  }
}
